import React, { FC, useEffect, useState } from 'react';
import { Button, Modal, Select } from 'antd';
import { dateFormatter, mapToMenuWithDivider } from 'common/helpers';
import { ArrowDownShort, Calendar, Files } from 'common/svg';
import { IInventoryPendingAssignee } from 'entities/Inventory/Inventory.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  assignees: IInventoryPendingAssignee[];
  onClose: () => void;
  onSubmit: (assigneeId: number) => void;
}

const DATE_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const InventoryTransferActModal: FC<IComponentProps> = ({ open, loading, assignees, onClose, onSubmit }) => {
  const [selectedAssigneeId, setSelectedAssigneeId] = useState<number | null>(null);

  useEffect(() => {
    if (open && assignees.length) {
      setSelectedAssigneeId(assignees[0].id);
    }

    if (!open) {
      setSelectedAssigneeId(null);
    }
  }, [open, assignees]);

  const selectedAssignee = assignees.find((item) => item.id === selectedAssigneeId);
  const options = mapToMenuWithDivider(assignees.map((item) => ({ label: item.name, value: item.id })));

  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
  };

  const handleSubmit = () => {
    if (selectedAssigneeId) {
      onSubmit(selectedAssigneeId);
    }
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={440}
      centered
      open={open}
      onCancel={handleClose}
      destroyOnClose
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button
          key="submit"
          className="button-sm primary"
          loading={loading}
          disabled={!selectedAssigneeId}
          onClick={handleSubmit}
        >
          Отправить
        </Button>,
      ]}
    >
      <div className="mb-7">
        <Files />
      </div>

      <div className="ff-medium fs-m mb-4">Сформировать акт передачи</div>

      <div className="ff-regular fs-s color-dark-grey mb-4">
        Акт передачи будет сформирован за текущий период и отправлен на указанную почту
      </div>

      <div className="mb-6">
        <div className="ff-regular fs-xs color-dark-grey mb-2">Сотрудник</div>

        <Select
          rootClassName="redesign"
          className="w-full"
          options={options}
          value={selectedAssigneeId}
          onChange={setSelectedAssigneeId}
          placeholder="Выберите сотрудника"
          suffixIcon={<ArrowDownShort />}
          virtual={false}
        />
      </div>

      {selectedAssignee?.from && selectedAssignee?.until && (
        <div className="mb-6 flex align-center gap-4">
          <Calendar className="icon-dark-grey" />
          <span className="ff-medium fs-s">
            {dateFormatter(DATE_FORMAT, selectedAssignee.from)} — {dateFormatter(DATE_FORMAT, selectedAssignee.until)}
          </span>
        </div>
      )}
    </Modal>
  );
};
